/* eslint-disable @typescript-eslint/no-unused-expressions */
import api from "utilities/Axios";

export const getAllEquipments = () => {
  return api.get("/TagMeta/GetAllEquipments");
};

export const getEquipmentsByUnitId = (unitId = 0) => {
  return api.get(`/TagMeta/GetEquipmentsByUnitId?id=${unitId}`);
};

export const createEquipment = (equipment: any) => {
  return api.post("/TagMeta/CreateEquipment", equipment);
};

export const updateEquipment = (equipment: any) => {
  return api.post("/TagMeta/UpdateEquipment", equipment);
};

export const deleteEquipment = (id: any) => {
  return api.get(`/TagMeta/DeleteEquipment?id=${id}`);
};
